import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../components/LegalPage';

const About: React.FC = () => (
  <LegalPage title="About SilverScribe">
    <p>
      SilverScribe is a Canadian company helping seniors and their families take control
      of their personal health history. We compile a clear, consolidated Personal Health
      Summary from your authorized healthcare providers and your own records &mdash; giving
      you and your loved ones a single trusted view of your health information when it matters most.
    </p>

    <h2>Our Mission</h2>
    <p>
      We believe every Canadian deserves easy access to their own health history,
      in a format that works for them, their family, and their care team. SilverScribe brings
      scattered records together into one secure, up-to-date Summary you can share with
      emergency responders, new providers, or family caregivers.
    </p>

    <h2>What We Do</h2>
    <ul>
      <li>Compile a Personal Health Summary from your authorized healthcare providers</li>
      <li>Host your Summary securely online with multi-factor authentication</li>
      <li>Provide a printable Emergency Card with QR code for first responders</li>
      <li>Let you keep your Summary current with self-updates or provider retrievals</li>
    </ul>

    <h2>Our Commitment</h2>
    <p>
      SilverScribe operates in compliance with Ontario&rsquo;s Personal Health Information
      Protection Act (PHIPA) and Canada&rsquo;s Personal Information Protection and Electronic
      Documents Act (PIPEDA). Your information is stored and processed within Canadian data
      centres, encrypted in transit and at rest, and accessible only to you and those you
      authorize. See our <Link to="/privacy">Privacy Policy</Link> for full details.
    </p>

    <h2>Get in Touch</h2>
    <p>
      If you&rsquo;d like to learn more about SilverScribe, <Link to="/contact">contact us</Link> &mdash;
      we&rsquo;d love to hear from you.
    </p>
  </LegalPage>
);

export default About;
